// extracted by mini-css-extract-plugin
module.exports = {"bleu_clair":"#c0c8d7","bleu":"#1c2b4e","blanc":"#f5f5f6"};